import React from 'react'
import { Button as SemanticButton } from 'semantic-ui-react'

import themeStyles from './styles'
import { mergeStyles } from '@enlyt/base'
import { useTheme } from 'contexts/ThemeProvider'
import { localization } from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const Button = ({ t, ...props }) => {
  const { theme } = useTheme()
  const styles = mergeStyles(themeStyles(theme), props.style)
  return (
    <SemanticButton
      {...props}
      style={styles.button}
      disabled={props.loading}
    >
      {t('loadMore')}
    </SemanticButton>
  )
}

export default withLocalization(Button, localization)
